export default "__VITE_ASSET__cb410aad__"